export const formsHandler = {
    init: function () {
        formsHandler.checkbox();
        formsHandler.checkboxChaines();
        // formsHandler.radio();
        // formsHandler.date();

        // Custom - Group filters
        formsHandler.groupFilters();

        // formsHandler.resetFilters();
    },

    checkbox: function () {

        let $checkboxes = document.querySelectorAll('.checkbox input[type="checkbox"]');
        if ($checkboxes) {
            Array.prototype.forEach.call($checkboxes, function ($checkbox, i) {
                // Set once
                setCheckbox($checkbox);
                // Toggle on change
                $checkbox.addEventListener('change', function () {
                    setCheckbox($checkbox);
                });
            });
        }

        function setCheckbox($checkbox) {
            if ($checkbox.checked === true) {
                $checkbox.closest('.checkbox, .checkbox-alt').classList.add('checked');
                $checkbox.closest('.checkbox, .checkbox-alt').classList.remove('indeterminate');
            } else if ($checkbox.indeterminate === true) {
                $checkbox.closest('.checkbox, .checkbox-alt').classList.add('indeterminate');
            } else {
                $checkbox.closest('.checkbox, .checkbox-alt').classList.remove('checked', 'indeterminate');
            }
        }

    },

    checkboxChaines: function () {

        let $checkboxes = document.querySelectorAll('.checkbox-chaine input[type="checkbox"]');
        if ($checkboxes) {
            Array.prototype.forEach.call($checkboxes, function ($checkbox, i) {
                // Set once
                setCheckbox($checkbox);
                fadeCheckboxes();
                // Toggle on change
                $checkbox.addEventListener('change', function () {
                    setCheckbox($checkbox);
                    fadeCheckboxes();
                });
            });
        }

        function setCheckbox($checkbox) {
            if ($checkbox.checked === true) {
                $checkbox.closest('.checkbox-chaine').classList.add('checked');
                $checkbox.closest('.checkbox-chaine').classList.remove('indeterminate');
            } else if ($checkbox.indeterminate === true) {
                $checkbox.closest('.checkbox-chaine').classList.add('indeterminate');
            } else {
                $checkbox.closest('.checkbox-chaine').classList.remove('checked', 'indeterminate');
            }
        }

        function fadeCheckboxes() {
            let $checkboxes_filtered = Array.from($checkboxes).filter(node => !node.closest('.checkbox-chaine').classList.contains('checked'));
            Array.prototype.forEach.call($checkboxes, ($checkbox) => {
                $checkbox.closest('.checkbox-chaine').classList.remove('faded');
            });
            Array.prototype.forEach.call($checkboxes_filtered, ($checkbox) => {
                if ($checkboxes_filtered.length !== $checkboxes.length) {
                    $checkbox.closest('.checkbox-chaine').classList.add('faded');
                }
            });
        }

    },

    radio: function () {

        let $radios = document.querySelectorAll('.radio input[type="radio"]');
        if ($radios) {
            Array.prototype.forEach.call($radios, function ($radio, i) {
                // Set once
                setRadio($radio);
                // Toggle on change
                $radio.addEventListener('change', function () {
                    let $group = $radio.closest('.radio-group');
                    if ($group) {
                        resetRadioGroup($group);
                    } else {
                        setRadio($radio);
                    }
                });
            });
        }

        function setRadio($radio) {
            if ($radio.checked === true) {
                $radio.closest('.radio, .radio-alt').classList.add('checked');
            } else {
                $radio.closest('.radio, .radio-alt').classList.remove('checked');
            }
        }

        function resetRadioGroup($group) {
            let $radios = $group.querySelectorAll('.radio input[type="radio"]');
            if ($radios) {
                Array.prototype.forEach.call($radios, function ($radio, i) {
                    setRadio($radio)
                });
            }
        }

    },

    date: function () {

        let $dates = document.querySelectorAll('.date input');
        if ($dates) {
            Array.prototype.forEach.call($dates, function ($date, i) {

                $date.addEventListener('blur', function () {
                    setDatePlaceholder($date);
                });

                $date.addEventListener('focusin', function () {
                    setDatePlaceholder($date);
                });

            });
        }

        function setDatePlaceholder($fieldDate) {
            let $placeholder = $fieldDate.parentNode.querySelector('.date-placeholder');
            if ($fieldDate.value && $fieldDate.value.split('-').length > 0) {
                let date = $fieldDate.value.split('-');
                $placeholder.innerHTML = date[2] + '/' + date[1] + '/' + date[0];
                $placeholder.classList.add('has-value');
            } else {
                $placeholder.innerHTML = $placeholder.dataset.label;
                $placeholder.classList.remove('has-value');
            }
        }

    },

    groupFilters: () => {
        let $groups = document.querySelectorAll('.checkbox-group-wrapper');
        if ($groups) {

            let maxItems = 0;
            let $groups_filtered = Array.from($groups).filter(node => node.querySelectorAll('.input--field').length > maxItems);

            if ($groups_filtered.length > 0) {

                Array.prototype.forEach.call($groups_filtered, ($group) => {

                    // Prepare button
                    let $btnExp = document.createElement('button');
                    $btnExp.type = "button";
                    $btnExp.classList.add('btn-default', 'btn--toggle-filters');
                    $btnExp.dataset.labelOn = 'Voir plus';
                    $btnExp.dataset.labelOff = 'Voir moins';
                    $btnExp.innerHTML = '<span class="button--label">' + $btnExp.dataset.labelOn + '</span>';
                    $btnExp.innerHTML += '<svg class="icon icon-caret" aria-hidden="true" focusable="false"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-caret"></use></svg>';

                    let hiddenItems = [];
                    // Prepare Expandable div
                    let $filtersExp = document.createElement('div');
                    $filtersExp.classList.add('checkbox-group-expandable');

                    let $items = $group.querySelectorAll('.input--field');

                    Array.prototype.forEach.call($items, ($item, i) => {
                        if (i >= maxItems) {
                            hiddenItems.push($item);
                            $item.parentNode.removeChild($item);
                        }
                    });

                    for (let i = 0; i < hiddenItems.length; i++) {
                        $filtersExp.appendChild(hiddenItems[i]);
                    }

                    $group.appendChild($filtersExp);
                    $group.appendChild($btnExp);

                    $btnExp.addEventListener('click', (e) => {
                        e.preventDefault();
                        let $button = e.target.closest('button');
                        let $filtersExp = $button.parentNode.querySelector('.checkbox-group-expandable');
                        let $filters = $filtersExp.querySelectorAll('.input--field');

                        let $filtersHeight = 0;
                        if ($filtersExp.classList.contains('expanded')) {
                            $filtersExp.classList.remove('expanded');
                            $filtersExp.style.maxHeight = $filtersHeight + 'px';
                            // $btnExp.innerHTML = '<svg class="icon icon-plus" aria-hidden="true" focusable="false"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-plus"></use></svg>';
                            $btnExp.innerHTML = '<span class="button--label">' + $btnExp.dataset.labelOn + '</span>';
                            $btnExp.innerHTML += '<svg class="icon icon-caret" aria-hidden="true" focusable="false"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-caret"></use></svg>';
                        } else {
                            // $filtersHeight += $btnExp.clientHeight;
                            Array.prototype.forEach.call($filters, ($filter) => {
                                let height = $filter.clientHeight;
                                height += parseInt(window.getComputedStyle($filter).getPropertyValue('margin-top'));
                                height += parseInt(window.getComputedStyle($filter).getPropertyValue('margin-bottom'));
                                $filtersHeight += height;
                            });
                            $filtersExp.classList.add('expanded');
                            $filtersExp.style.maxHeight = $filtersHeight + 'px';
                            $btnExp.innerHTML = '<span class="button--label">' + $btnExp.dataset.labelOff + '</span>';
                            $btnExp.innerHTML += '<svg class="icon icon-caret" aria-hidden="true" focusable="false"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-caret"></use></svg>';
                        }
                    });

                });

            }
        }
    },

    resetFilters: () => {

        let $filters = document.querySelector('.posts--filters');
        if (!$filters)
            return;

        let $btnReset = $filters.querySelector('.btn--filters-reset');
        let $inputsCheck = $filters.querySelectorAll('.input--field.checkbox, .input--field.radio');
        let $inputsValue = $filters.querySelectorAll('.input--field.text, .input--field.textarea');
        let $inputsDate = $filters.querySelectorAll('.input--field.date');

        $btnReset.addEventListener('click', () => {
            Array.prototype.forEach.call($inputsCheck, ($inputCheck) => {
                $inputCheck.classList.remove('checked');
                $inputCheck.querySelector('input').checked = false;
            });
            Array.prototype.forEach.call($inputsValue, ($inputValue) => {
                $inputValue.querySelector('input').value = '';
            });
            Array.prototype.forEach.call($inputsDate, ($inputDate) => {
                let $placeholder = $inputDate.querySelector('.date-placeholder');
                $inputDate.querySelector('input').value = '';
                $placeholder.innerHTML = $placeholder.dataset.label;
                $placeholder.classList.remove('has-value');
            });

            // Trigger 'change' event on first input only (perf.)
            let $inputs = $filters.querySelectorAll('input');
            $inputs.item(1).dispatchEvent(new Event('change', { 'bubbles': true }))
        })

    }
}